import { useMemo } from 'react';
import { getClient } from '../requests.mjs';
import useResult from '../response';

export default function useGetClient(auth, clientId, siteId = null) {
  const request = useMemo(function () {
    return getClient(auth, clientId, siteId);
  }, []);
  return useResult(request);
}
